import React, { useEffect, useState, useImperativeHandle, forwardRef } from 'react';
import Select from 'react-select';
import useWindowSize from './useWindowSize';
import { newServicesAction } from '../../_actions';
import { toast } from '../shared/Toast';
import { connect, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';


  const teamOptionsforSelfEmp = [
    { value: 1, label: 'Share services & categories with other staff' },
    { value: 0, label: 'Don’t share services & categories with other staff' },
  ];


const ServicePopup = forwardRef(function ServicePopup(props, ref) {
  const teamOptions =  props?.user?.userInfo?.hairdresser?.isSalonOwner === 1 ?
  [
    { value: 1, label: 'Share services & categories with self employed staff' },
    { value: 0, label: 'Don’t share services & categories with self employed staff' },
  ]:[
    { value: 1, label: 'Share services & categories with other staff' },
    { value: 0, label: 'Don’t share services & categories with other staff' },
  ]
  // console.log("props?.user?.userInfo?.hairdresser?.isSalonOwner",props?.user?.userInfo?.hairdresser?.isSalonOwner)
  const dispatch = useDispatch();
    const [shareTeamMember, setShareTeamMember] = useState(teamOptions.find(option => option.value === props.selectedSetting));
    console.log("shareTeamMember_setting",shareTeamMember)
  //  console.log("props.selectedSetting",props.selectedSetting,"and===>" ,teamOptions[0])
    const { width } = useWindowSize();
    const menuPlacementPosition = width > 991 ? 'bottom' : 'top';
    // const handleApply = () => {
    //   console.log("shareTeamMember" ,shareTeamMember)
    //     setShareTeamMember(shareTeamMember.value)
    //     handleServiceSettings(shareTeamMember.value)
  
       
    //   }
    
    const customStyles = {
      control: (provided, state) => ({
        ...provided,
        border: state.isFocused ? '1px solid #007EA0' : '1px solid #e0e0e0',
        borderRadius: '10px',
        minHeight: '44px',
        boxShadow: state.isFocused ? '0 0 0 3px rgba(0, 126, 160, 0.08)' : 'none',
        background: '#fff',
        cursor: 'pointer',
        transition: 'border-color 0.15s ease, box-shadow 0.15s ease',
        '&:hover': {
          borderColor: state.isFocused ? '#007EA0' : '#ccc',
        },
      }),
      indicatorSeparator: () => ({ display: 'none' }),
      dropdownIndicator: (provided) => ({
        ...provided,
        color: '#999',
        padding: '8px 10px',
        '&:hover': { color: '#666' },
      }),
      singleValue: (provided) => ({
        ...provided,
        fontSize: '14px',
        color: '#333',
      }),
      placeholder: (provided) => ({
        ...provided,
        fontSize: '14px',
        color: '#aaa',
      }),
      menu: (provided) => ({
        ...provided,
        borderRadius: '12px',
        border: '1px solid #e8e8e8',
        boxShadow: '0 8px 24px rgba(0, 0, 0, 0.1), 0 2px 8px rgba(0, 0, 0, 0.04)',
        overflow: 'hidden',
        zIndex: 20,
        marginTop: '4px',
        marginBottom: '4px',
      }),
      menuList: (provided) => ({
        ...provided,
        padding: '4px',
        maxHeight: '240px',
      }),
      option: (provided, state) => ({
        ...provided,
        fontSize: '14px',
        padding: '10px 12px',
        borderRadius: '8px',
        cursor: 'pointer',
        transition: 'background 0.1s ease',
        backgroundColor: state.isSelected ? '#29282D' : state.isFocused ? '#f0f0f0' : '#fff',
        color: state.isSelected ? '#fff' : '#333',
        '&:active': {
          backgroundColor: state.isSelected ? '#29282D' : '#e8e8e8',
        },
      }),
    };
      useImperativeHandle(ref, () => ({ apply: handleServiceSettings }));

      const handleServiceSettings = () =>{
        let payload = {
          "shareService": shareTeamMember.value
        }
        console.log("payload_od_setting",payload)
        dispatch(newServicesAction.serviceShareSetting(payload))
          .then((res) => {
            console.log("serviceShareSetting successfully response =>:", res);
            if(res?.serviceShareSetting?.statusCode===1) {
              props.servicesList()
              props.onHide();
              toast.success(res?.serviceShareSetting?.responseData?.message);
              
           }
           else{
            //  toast.error(res?.editCategory?.error? res?.editCategory?.error?.responseMessage : res?.editCategory?.responseData?.message);
           }
          
           props.servicesList()
            
            
          })
          .catch((error) => {
            console.error("Error edit category:", error);
          });
      }
      
      console.log("shareTeamMembershareTeamMember",shareTeamMember)
      useEffect(()=>{

      })
  return (
    <div className="filters-popup pb-0">
        
    <div className="filter-group">
      <label>Service List Sharing</label>
      <Select
        menuPlacement={menuPlacementPosition}
        classNamePrefix="my-select"
        value={shareTeamMember}
        onChange={setShareTeamMember}
        options={teamOptions}
        styles={customStyles}
        isSearchable={false}
        // menuIsOpen={true}

      />
      {/* Who is actually on the salon's services, and why anyone isn't. */}
      <Link
        to="/settings/sharing?tab=services"
        onClick={() => props.onHide && props.onHide()}
        style={{ display: 'inline-block', marginTop: 14, fontSize: 14, fontWeight: 600, color: '#007EA0' }}
      >
        See who&rsquo;s sharing services
      </Link>
    </div>
    {/* <div className="filter-group">
      <label> Which staff can edit and delete services added by manager</label>
    <div className='_checkbox'>
       <div className="check_wraper  mb-4">
           <input
               type="checkbox"
            //    checked={this.state.isCancelChecked}
               name="allow"
            //    onChange={this.checkBoxChange}
               // disabled={this.checkReadOnly() ? "" : "disabled"}
           />
           <span /><p className='_text'>Joel Wild</p>
       </div>
       <div className="check_wraper  mb-3">
           <input
               type="checkbox"
            //    checked={this.state.isCancelChecked}
               name="allow"
            //    onChange={this.checkBoxChange}
               // disabled={this.checkReadOnly() ? "" : "disabled"}
           />
           <span /><p className='_text'>Charlie Marjot</p>
       </div>
    </div>
    </div> */}
  </div>
  )
});

// export default ServicePopup

function mapStateToProps(state) {
  return {
      ...state
  };
}
export default connect(mapStateToProps, null, null, { forwardRef: true })(ServicePopup);